<div class="dialog-box card">
  <div class="card-header mb-0">
    Add Mobile Form
    <span class="float-end" (click)="onCloseDialog(false)">
      <i class="fa-solid fa-xmark"></i>
    </span>
  </div>

  <div class="my-4">
    @if (userPromptTotalCount > 3) {
      <div>
        <gtapp-auto-complete
          [data]="userPromptsSearchResults"
          inputId="promptSelectId"
          placeHolder="Search Mobile Forms"
          searchKeyword="name"
          [itemTemplate]="promptLookupTemplate"
          (inputChanged)="searchPrompts($event)"
          (selected)="onCloseDialog($event)"
        >
        </gtapp-auto-complete>
      </div>
      <ng-template #promptLookupTemplate let-item>
        <div class="fw-bold">
          {{ item?.name }}
        </div>
      </ng-template>
    }

    <div class="d-flex gap-2 my-2 flex-wrap">
      @for (prompt of userPromptsSearchResultsCopy; track prompt?.id) {
        <div
          (click)="onCloseDialog(prompt)"
          role="button"
          class="p-2 border rounded bg-secondary-subtle d-flex align-items-center justify-content-between gap-3 hover"
          [class.opacity-50]="!selectedPromptIds?.includes(prompt?.id)"
        >
          <i class="fa-solid fa-clipboard-list text-success"></i>
          <div class="fw-semibold small text-dark">
            {{ prompt?.name }}
          </div>
        </div>
      }
    </div>
  </div>
  <!-- <div class="mb-5 text-end text-secondary small">
      Added Mobile Forms: {{ getPromptsInCheckList(data) }}
    </div>
    <div class="row row-cols-2">
      <div class="col">
        <button
          class="btn btn-light btn-lg w-100"
          (click)="addPromptTemplateRef.close(false)"
        >
          Clear
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          (click)="addPromptTemplateRef.close(true)"
        >
          Submit
        </button>
      </div>
    </div> -->
</div>
